import React from "react";

import Organisation from "@/models/Organisation";
import { cn } from "@/lib/utils";

const WEEKDAY_KEYS = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
	"sunday",
] as const;
const WEEKDAY_INITIALS = ["M", "T", "O", "T", "F", "L", "S"];

/**
 * The consultant's weekly profile availability as one block per org
 * availability shift and day — the Tailwind counterpart of the legacy
 * `WeeklyAvailability` bars. Used by the consultant panel and the
 * Kandidater tab.
 */
const AvailabilityStrip: React.FC<{
	availability?: Record<string, { start: string; end: string }[]>;
	organisation?: Organisation;
}> = ({ availability, organisation }) => {
	const slots = organisation?.availabilityShifts;
	if (!slots?.length) return null;

	return (
		<div className="flex items-center gap-[5px] xl:gap-1.5">
			{WEEKDAY_KEYS.map((day, index) => {
				const frames = availability?.[day] ?? [];
				const times = frames.map((frame) => `${frame.start}–${frame.end}`).join(", ");
				return (
					<div
						key={day}
						title={`${WEEKDAY_INITIALS[index]}: ${times || "–"}`}
						className="flex gap-px"
					>
						{slots.map((slot, slotIndex) => (
							<span
								key={slotIndex}
								className={cn(
									// Taller blocks and a darker "unavailable" fill: at h-3 with
									// gray-200 the strip read as haze rather than data
									"h-3.5 w-1.5 rounded-[1px] xl:h-4 xl:w-2",
									frames.some((frame) => frame.start === slot.start) ? "bg-success" : "bg-gray-300"
								)}
							/>
						))}
					</div>
				);
			})}
		</div>
	);
};

export default AvailabilityStrip;
